import { ErrorMessage } from 'formik'
import React from 'react'
import Select from 'react-select'
import TextError from '../../../components/TextError'
import { customStyles } from '../../../components/customStyles'
import { isInventoryModel } from '../../../lib/AllStaticVariables'
import ReactSelect from '../../../components/ReactSelect'

const AppliesOn = ({
  values,
  setFieldValue,
  setAllState,
  allState,
  loading,
  setLoading,
  fetchAllGenericData,
  isDisabled
}) => {
  return (
    <>
      <div className='col-md-6 input-file-wrapper mb-3'>
        <label className='form-label required'>Apply coupon on</label>
        <ReactSelect
          name='applyOn'
          id='applyOn'
          isDisabled={isDisabled}
          value={
            values?.applyOn && {
              label: values?.applyOn,
              value: values?.applyOn
            }
          }
          placeholder='Apply Coupon On'
          options={
            isInventoryModel
              ? [
                  { label: 'All Products', value: 'All Products' },
                  {
                    label: 'Specific Products',
                    value: 'Specific Products'
                  },
                  {
                    label: 'Specific Categories',
                    value: 'Specific Categories'
                  },
                  { label: 'Specific Brands', value: 'Specific Brands' },
                  { label: 'Specific Users', value: 'Specific Users' }
                ]
              : [
                  { label: 'All Products', value: 'All Products' },
                  {
                    label: 'Specific Products',
                    value: 'Specific Products'
                  },
                  {
                    label: 'Specific Categories',
                    value: 'Specific Categories'
                  },

                  {
                    label: 'Specific Sellers',
                    value: 'Specific Sellers'
                  },
                  { label: 'Specific Brands', value: 'Specific Brands' },
                  { label: 'Specific Users', value: 'Specific Users' }
                ]
          }
          onChange={async (e) => {
            let apiUrls = []
            setFieldValue('applyOn', e?.value)
            switch (e?.value) {
              case 'Specific Products':
                if (!allState?.product?.length)
                  apiUrls.push({
                    endpoint: 'Product/AllChildProducts',
                    queryString: '',
                    state: 'product'
                  })
                break
              case 'Specific Categories':
                if (!allState?.category?.length)
                  apiUrls.push({
                    endpoint: 'MainCategory/getAllCategory',
                    queryString: '?pageSize=0&pageIndex=0',
                    state: 'category'
                  })
                break
              case 'Specific Brands':
                if (!allState?.brand?.length) {
                  apiUrls.push({
                    endpoint: 'Brand/search',
                    queryString: '?pageSize=0&pageIndex=0&status=Active',
                    state: 'brand'
                  })
                }
                if (!allState?.category?.length)
                  apiUrls.push({
                    endpoint: 'MainCategory/getAllCategory',
                    queryString: '?pageSize=0&pageIndex=0',
                    state: 'category'
                  })
                break
              case 'Specific Sellers':
                if (!allState?.category?.length) {
                  apiUrls.push({
                    endpoint: 'MainCategory/getAllCategory',
                    queryString: '?pageSize=0&pageIndex=0',
                    state: 'category'
                  })
                }
                if (!allState?.seller?.length) {
                  apiUrls.push({
                    endpoint: 'SellerData/bindActiveSeller',
                    queryString: '?pageindex=0&PageSize=0',
                    state: 'seller'
                  })
                }
                if (!allState?.brand?.length) {
                  apiUrls.push({
                    endpoint: 'Brand/search',
                    queryString: '?pageSize=0&pageIndex=0&status=Active',
                    state: 'brand'
                  })
                }
                break
              case 'Specific Users':
                // apiUrls([])
                apiUrls.push({
                  endpoint: 'CustomerData',
                  queryString: '?pageIndex=0&pageSize:0',
                  state: 'user'
                })
                break

              default:
                break
            }

            if (apiUrls?.length) {
              setLoading(true)
              const responses = await fetchAllGenericData(apiUrls)
              setLoading(false)
              responses.forEach((response) => {
                switch (response.state) {
                  case 'product':
                    setAllState((draft) => {
                      draft.product = response?.data
                    })
                    break

                  case 'brand':
                    setAllState((draft) => {
                      draft.brand = response?.data
                    })
                    break

                  case 'seller':
                    setAllState((draft) => {
                      draft.seller = response?.data
                    })
                    break

                  case 'category':
                    setAllState((draft) => {
                      draft.category = response?.data
                    })
                    break

                  case 'user':
                    setAllState((draft) => {
                      draft.users = response?.data
                    })
                    break

                  default:
                    break
                }
              })
            }
            setFieldValue('offerItems', [])
          }}
        />
      </div>
      {values?.applyOn === 'Specific Categories' && (
        <div className='col-md-6'>
          <div className='input-file-wrapper mb-3'>
            <label className='form-label required'>Select Category</label>
            <ReactSelect
              isMulti
              isDisabled={isDisabled}
              name='offerItems'
              id='offerItems'
              placeholder='Select Category'
              value={
                values?.offerItems &&
                values?.offerItems?.map((data) => {
                  return {
                    label: allState?.category?.find(
                      (obj) => obj?.id === data?.categoryId
                    )?.pathNames,
                    value: data?.categoryId
                  }
                })
              }
              options={
                allState?.category?.map(({ id, pathNames }) => ({
                  value: id,
                  label: pathNames
                })) ?? []
              }
              onChange={(e) => {
                let offerItems = values?.offerItems ?? []
                offerItems = e?.map((item) => {
                  return {
                    categoryId: item?.value,
                    productId: 0,
                    brandId: 0,
                    sellerId: '',
                    userId: '',
                    status: '',
                    optInSellerIds: '',
                    getDiscountType: '',
                    offerId: 0,
                    getProductId: 0,
                    getDiscountValue: 0,
                    getProductPrice: 0,
                    sellerOptIn: values?.sellerOptIn,
                    brandids: '',
                    categoryIds: '',
                    sellerIds: ''
                  }
                })
                setFieldValue('offerItems', offerItems)
              }}
            />
          </div>
        </div>
      )}

      {values?.applyOn === 'Specific Products' && (
        <div className='col-md-6'>
          <div className='input-file-wrapper mb-3'>
            <label className='form-label required'>Select Product</label>
            <ReactSelect
              isMulti
              isDisabled={isDisabled}
              name='offerItems'
              id='offerItems'
              value={
                values?.offerItems &&
                values?.offerItems?.map((data) => {
                  return {
                    label: allState?.product?.find(
                      (obj) => obj?.productId === data?.productId
                    )?.productName,
                    value: data?.productId
                  }
                })
              }
              placeholder='Select Product'
              options={
                allState?.product?.map(({ productId, productName }) => ({
                  value: productId,
                  label: productName
                })) ?? []
              }
              onChange={(e) => {
                let offerItems = values?.offerItems ?? []
                offerItems = e?.map((item) => {
                  return {
                    productId: item?.value,
                    productName: item?.label,
                    categoryId: 0,
                    brandId: 0,
                    sellerId: '',
                    userId: '',
                    status: '',
                    optInSellerIds: '',
                    getDiscountType: '',
                    offerId: 0,
                    getProductId: 0,
                    getDiscountValue: 0,
                    getProductPrice: 0,
                    sellerOptIn: values?.sellerOptIn
                  }
                })
                setFieldValue('offerItems', offerItems)
              }}
            />
          </div>
        </div>
      )}

      {values?.applyOn === 'Specific Sellers' && (
        <>
          <div className='col-md-6'>
            <div className='input-file-wrapper mb-3'>
              <label className='form-label required'>Select Seller</label>
              <ReactSelect
                isMulti
                isDisabled={isDisabled}
                name='offerItems'
                id='offerItems'
                value={
                  values?.offerItems &&
                  values?.offerItems?.map((data) => {
                    return {
                      label: allState?.seller?.find(
                        (obj) => obj?.userId === data?.sellerId
                      )?.displayName,
                      value: data?.sellerId
                    }
                  })
                }
                placeholder='Select Seller'
                options={
                  allState?.seller?.map(({ userId, displayName }) => ({
                    value: userId,
                    label: displayName
                  })) ?? []
                }
                onChange={(e) => {
                  const brandids = values?.offerItems[0]?.brandids || ''
                  const categoryIds = values?.offerItems[0]?.categoryIds || ''

                  let offerItems = e?.map((item) => {
                    return {
                      sellerId: item?.value,
                      sellerName: item?.label,
                      productId: 0,
                      brandId: 0,
                      categoryId: 0,
                      userId: '',
                      status: '',
                      optInSellerIds: '',
                      getDiscountType: '',
                      offerId: 0,
                      getProductId: 0,
                      getDiscountValue: 0,
                      getProductPrice: 0,
                      sellerOptIn: values?.sellerOptIn,
                      brandids,
                      categoryIds,
                      productIds: ''
                    }
                  })
                  setFieldValue('offerItems', offerItems)
                }}
              />
            </div>
          </div>
          {values?.offerItems?.length > 0 && (
            <>
              <div className='col-md-6'>
                <div className='input-file-wrapper mb-3'>
                  <label className='form-label'>Select Brands</label>
                  <ReactSelect
                    isMulti
                    isDisabled={isDisabled}
                    name='offerItems'
                    id='offerItems'
                    placeholder='Select brands'
                    value={
                      values?.offerItems?.length > 0 &&
                      values?.offerItems[0]?.brandids
                        ? values?.offerItems[0]?.brandids
                            .split(',')
                            .map((id) => parseInt(id))
                            .map((id) => ({
                              label: allState?.brand?.find(
                                (obj) => obj?.id === id
                              )?.name,
                              value: id
                            }))
                        : []
                    }
                    options={
                      allState?.brand?.map(({ id, name }) => ({
                        value: id,
                        label: name
                      })) ?? []
                    }
                    onChange={(e) => {
                      let offerItems = values?.offerItems?.map(
                        (offerItem, i) => {
                          const brandIds = e
                            ?.map((brand) => brand?.value)
                            .join(',')
                          return { ...offerItem, brandids: brandIds }
                        }
                      )
                      setFieldValue('offerItems', offerItems)
                    }}
                  />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='input-file-wrapper mb-3'>
                  <label className='form-label'>Select Category</label>
                  <ReactSelect
                    isMulti
                    isDisabled={isDisabled}
                    name='offerItems'
                    id='offerItems'
                    placeholder='Select Category'
                    value={
                      values?.offerItems?.length > 0 &&
                      values?.offerItems[0]?.categoryIds
                        ? values?.offerItems[0]?.categoryIds
                            .split(',')
                            .map((id) => parseInt(id))
                            .map((id) => ({
                              label: allState?.category?.find(
                                (obj) => obj?.id === id
                              )?.pathNames,
                              value: id
                            }))
                        : []
                    }
                    options={
                      allState?.category?.map(({ id, pathNames }) => ({
                        value: id,
                        label: pathNames
                      })) ?? []
                    }
                    onChange={(e) => {
                      let offerItems = values?.offerItems?.map(
                        (offerItem, i) => {
                          const categoryIds = e
                            ?.map((category) => category?.value)
                            .join(',')
                          return { ...offerItem, categoryIds: categoryIds }
                        }
                      )
                      setFieldValue('offerItems', offerItems)
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </>
      )}

      {values?.applyOn === 'Specific Brands' && (
        <>
          <div className='col-md-6'>
            <div className='input-file-wrapper mb-3'>
              <label className='form-label required'>Select Brand</label>
              <ReactSelect
                isMulti
                isDisabled={isDisabled}
                name='offerItems'
                id='offerItems'
                placeholder='Select brand'
                value={
                  values?.offerItems &&
                  values?.offerItems?.map((data) => {
                    return {
                      label: allState?.brand?.find(
                        (obj) => obj?.id === data?.brandId
                      )?.name,
                      value: data?.brandId
                    }
                  })
                }
                options={
                  allState?.brand?.map(({ id, name }) => ({
                    value: id,
                    label: name
                  })) ?? []
                }
                onChange={(e) => {
                  const categoryIds = values?.offerItems[0]?.categoryIds || ''
                  let offerItems = e?.map((item) => {
                    return {
                      brandId: item?.value,
                      brandName: item?.label,
                      productId: 0,
                      sellerId: null,
                      categoryId: 0,
                      userId: null,
                      status: null,
                      optInSellerIds: null,
                      getDiscountType: null,
                      offerId: 0,
                      getProductId: 0,
                      getDiscountValue: 0,
                      getProductPrice: 0,
                      sellerOptIn: values?.sellerOptIn,
                      categoryIds
                    }
                  })
                  setFieldValue('offerItems', offerItems)
                }}
              />
            </div>
          </div>
          {values?.offerItems?.length > 0 && (
            <div className='col-md-6'>
              <div className='input-file-wrapper mb-3'>
                <label className='form-label'>Select Category</label>
                <ReactSelect
                  isMulti
                  isDisabled={isDisabled}
                  name='offerItems'
                  id='offerItems'
                  placeholder='Select Category'
                  value={
                    values?.offerItems?.length > 0 &&
                    values?.offerItems[0]?.categoryIds
                      ? values?.offerItems[0]?.categoryIds
                          .split(',')
                          .map((id) => parseInt(id))
                          .map((id) => ({
                            label: allState?.category?.find(
                              (obj) => obj?.id === id
                            )?.pathNames,
                            value: id
                          }))
                      : []
                  }
                  options={
                    allState?.category?.map(({ id, pathNames }) => ({
                      value: id,
                      label: pathNames
                    })) ?? []
                  }
                  onChange={(e) => {
                    let offerItems = values?.offerItems?.map((offerItem, i) => {
                      const categoryIds = e
                        ?.map((category) => category?.value)
                        .join(',')
                      return { ...offerItem, categoryIds: categoryIds }
                    })
                    setFieldValue('offerItems', offerItems)
                  }}
                />
              </div>
            </div>
          )}
        </>
      )}
      {values?.applyOn === 'Specific Users' && (
        <>
          <div className='col-md-6'>
            <div className='input-file-wrapper mb-3'>
              <label className='form-label required'>Select User</label>
              <ReactSelect
                isMulti
                isDisabled={isDisabled}
                name='offerItems'
                id='offerItems'
                placeholder='Select User'
                value={
                  values?.offerItems &&
                  values?.offerItems?.map((data) => {
                    const record = allState?.users?.find(
                      (obj) => obj?.id === data?.userId
                    )
                    return {
                      label:
                        record?.firstName +
                        ' ' +
                        record?.lastName +
                        ' - ' +
                        record?.userName,
                      value: record?.id
                    }
                  })
                }
                options={
                  allState?.users?.map(
                    ({ id, firstName, lastName, userName }) => ({
                      value: id,
                      label: firstName + ' ' + lastName + ' - ' + userName
                    })
                  ) ?? []
                }
                onChange={(e) => {
                  const userIds = values?.offerItems[0]?.userIds || ''
                  let offerItems = e?.map((item) => {
                    return {
                      brandId: 0,
                      brandName: null,
                      productId: 0,
                      sellerId: null,
                      categoryId: 0,
                      userId: item?.value,
                      userName: item?.label,
                      status: null,
                      optInSellerIds: null,
                      getDiscountType: null,
                      offerId: 0,
                      getProductId: 0,
                      getDiscountValue: 0,
                      getProductPrice: 0,
                      sellerOptIn: values?.sellerOptIn
                    }
                  })
                  setFieldValue('offerItems', offerItems)
                }}
              />
            </div>
          </div>
          {/* {values?.offerItems?.length > 0 && (
            <div className='col-md-6'>
              <div className='input-file-wrapper mb-3'>
                <label className='form-label required'>Select Category</label>
                <Select
                  styles={customStyles}
                  menuPortalTarget={document.body}
                  isMulti
                  name='categoryIds'
                  placeholder='Select Category'
                  value={
                    values?.offerItems?.length > 0 &&
                    values?.offerItems[0]?.categoryIds
                      ? values?.offerItems[0]?.categoryIds
                          .split(',')
                          .map((id) => parseInt(id))
                          .map((id) => ({
                            label: allState?.category?.find(
                              (obj) => obj?.id === id
                            )?.pathNames,
                            value: id
                          }))
                      : []
                  }
                  options={
                    allState?.category?.map(({ id, pathNames }) => ({
                      value: id,
                      label: pathNames
                    })) ?? []
                  }
                  onChange={(e) => {
                    let offerItems = values?.offerItems?.map((offerItem, i) => {
                      const categoryIds = e
                        ?.map((category) => category?.value)
                        .join(',')
                      return { ...offerItem, categoryIds: categoryIds }
                    })
                    setFieldValue('offerItems', offerItems)
                  }}
                />
                <ErrorMessage name='offerItems' component={TextError} />
              </div>
            </div>
          )} */}
        </>
      )}
    </>
  )
}

export default AppliesOn
